import { createFileRoute, Outlet } from "@tanstack/react-router";
import { contactFilterSchema } from "@/contacts/schemas/contactFilterSchema";

export const Route = createFileRoute("/(authed)/_layout/contacts")({
  component: RouteComponent,
  validateSearch: contactFilterSchema,
  loader: () => {
    return {
      crumb: "Contacts",
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
